var React = require('react');

function LogoProcessingPython (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M300 100C600 100 600 500 300 500","stroke":"#104B58","strokeWidth":"150","key":0}),React.createElement("path",{"d":"M300 700C0 700 0 300 300 300","stroke":"#2D9E97","strokeWidth":"150","key":1}),React.createElement("path",{"d":"M400 700H700","stroke":"#8CE4DF","strokeWidth":"150","key":2})]);
}

LogoProcessingPython.defaultProps = {"width":"800","height":"800","viewBox":"0 0 800 800","fill":"none"};

module.exports = LogoProcessingPython;

LogoProcessingPython.default = LogoProcessingPython;
